import React from 'react';
import { TConnector, TField, TProductCategory } from '../../DefineModel/model';
import {DragIcon} from "../../../../../../assests/GmsIcons";
import {CONNECTOR} from "../../../ISRConstants";

type TSubmodleFieldItemProps = {
    dragHandleProps?: any;
    field? : TField | TProductCategory | TConnector;
    fieldName: string;
    fieldType: string;
    fieldIdentifier?: string;
    fieldAddition?: any;
    addField?: boolean;
}

const SubmodleFieldItem = ({dragHandleProps, field, fieldName, fieldType, fieldIdentifier, fieldAddition, addField}: TSubmodleFieldItemProps) => {

    return (
        <div role="button" data-testid="components-submodlefielditem-div-1" onClick={() => {}} className={`tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-auto tw-flex tw-flex-row tw-items-center tw-justify-between tw-py-[3px] tw-px-3 tw-gap-[12px]  tw-border-[1px] tw-border-solid ${'tw-border-grey-200 tw-text-shades-of-grey-60'}`}>
            {dragHandleProps ? <div {...dragHandleProps}>
                <DragIcon />
            </div> : null}
            <div className={'flex-grow-1'}>
                <label className='tw-text-xs tw-block'>{fieldName ?? ''}</label>
                <label className='tw-text-xs tw-text-[#747593] tw-block'>{(fieldType ?? '').replace("Connector", CONNECTOR)}</label>
            </div>
            { addField && <button data-testid="components-submodlefielditem-button-1" onClick={() => fieldAddition(fieldIdentifier, field) } className='tw-text-primary'>Add</button> }
        </div>
    );
}

export default SubmodleFieldItem;